export default "__VITE_ASSET__CKldc9RY__"